import { useEffect } from 'react';
import { preloadImages } from 'utils/appHelpers';
import Image1 from 'assets/images/logo-icon.svg';
import Image2 from 'assets/images/glasses.png';
import Image3 from 'assets/images/onboarding_snap_save_1.png';
import Image4 from 'assets/images/onboarding_snap_save_2.png';
import Image5 from 'assets/images/onboarding_snap_save_3.png';
import Image6 from 'assets/images/girl.png';
import Image7 from 'assets/images/girl-1.png';
import Image8 from 'assets/images/girl-2.png';
import Image9 from 'assets/images/stats.png';
import Image10 from 'assets/images/img-n.png';
import Image11 from 'assets/images/traces.png';
import Image12 from 'assets/images/question.png';
import Image13 from 'assets/images/onboarding_gifts_1.png';
import Image14 from 'assets/images/onboarding_gifts_2.png';
import Image15 from 'assets/images/onboarding_gifts_3.svg';
import Image16 from 'assets/images/onboarding_gifts_4.png';
import Image17 from 'assets/images/onboarding_organize_ad_1.png';
import Image18 from 'assets/images/onboarding_organize_ad_2.png';
import Image19 from 'assets/images/onboarding_organize_ad_3.png';

const PreloadImagesComponent = () => {
  useEffect(() => {
    preloadImages([
      Image1,
      Image2,
      Image3,
      Image4,
      Image5,
      Image6,
      Image7,
      Image8,
      Image9,
      Image10,
      Image11,
      Image12,
      Image13,
      Image14,
      Image15,
      Image16,
      Image17,
      Image18,
      Image19,
    ]);
  }, []);

  return null;
};

export default PreloadImagesComponent;
